
import VueGtm                     from 'vue-gtm';
import VueGtag                    from "vue-gtag";
import Vue from "vue";

const CHECKOUT_ROUTES = ['/payment']

function isCheckoutRoute() {
    if (typeof window === 'undefined') return false
    const pathname = window.location.pathname
    return CHECKOUT_ROUTES.some(route => pathname === route || pathname.startsWith(route + '/'))
}

export default ({ store, app: { router, context } }, inject) => {

    if (isCheckoutRoute()) {
        console.log('[Analytics] Skipping GTM/GA on checkout route for CSP compliance')
        return
    }

    let account = store.getters.getAccount;

    // Set the default compliance to denied
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function(){ dataLayer.push(arguments); };

    // Google Consent Mode defaults (v2-safe):
    window.gtag('consent', 'default', {
        analytics_storage: 'denied',
        ad_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied',
        wait_for_update: 500 // optional small grace
    });

//Google Tag Manager using VueGtm
// if we havce a google tag manager container, add it to the plugin
if(account.tag_manager_container){
    Vue.use(VueGtm, {
      id: account.tag_manager_container, // Your GTM ID
      enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
      debug: false, // Whether or not display console logs debugs (optional)
      vueRouter: router, // Pass the router instance to automatically sync with router (optional)
      ignoredViews: ['payment'] // Exclude payment route for CSP compliance
    });
}

// Google Analytics using VueGtag
// VueGtag configuration object
var vueGtagConfig = {
    config: {
        id: process.env.VUE_APP_GA_ACCOUNT,
        params: {
            send_page_view:true,
            anonymize_ip : true,
        }
    },
};

// if the account have a google Analytics, add it to VueGtat object
if(account.ga_tracking_id) {
    vueGtagConfig['includes'] = [{
        id: account.ga_tracking_id,
        params: {
            send_page_view:true,
            anonymize_ip : true,
        }
    }];
}
// Google Analytics plugin setup
Vue.use(VueGtag, vueGtagConfig, router);

}